/**
 * @fileoverview Anonymization Settings View - controller for anonymize settings
 *
 * @author amywang@yext.com
 * @author nliang@yext.com
 */
goog.module('yext.storm.AnonymizationSettingsView');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const IndividualComplianceSettingView = goog.require('yext.storm.IndividualComplianceSettingView');

/**
 * @constructor
 * @extends {IndividualComplianceSettingView}
 */
const AnonymizationSettingsView = function() {
  /** @type {!jQuery} */
  this.$editFields = this.$el.find('.js-data');

  IndividualComplianceSettingView.call(this, this.$editFields);
};
goog.inherits(AnonymizationSettingsView, IndividualComplianceSettingView);

/** @override */
IndividualComplianceSettingView.prototype.doAdditionalBinding = function() {
  this.bindInputToModel_();
};

/** @override */
AnonymizationSettingsView.prototype.getAdditionalModelProperties = function() {
  return {
    'anonymizeEnabled': this.$editFields.find('.js-enabled:checked').val() == 'true',
    'anonymizeAfterMonths': this.$editFields.find('select').val(),
  };
};

/** @private */
AnonymizationSettingsView.prototype.bindInputToModel_ = function() {
  this.$el.find('.js-settings-field').inputchange(function(e) {
    var changes = this.getValue_();
    this.model.set('anonymizeEnabled', changes['anonymizeEnabled']);
    this.model.set('anonymizeAfterMonths', changes['anonymizeAfterMonths']);
  }.bind(this));
};

/** @override */
AnonymizationSettingsView.prototype.getData = function() {
  return {'settings': this.getValue_()};
};

/** @private */
AnonymizationSettingsView.prototype.getValue_ = function() {
  var enabled = this.$editFields.find('.js-enabled:checked').val() == 'true';
  var months = enabled ? this.$editFields.find('.js-input').val() : 0;
  return {
    'anonymizeEnabled': enabled,
    'anonymizeAfterMonths': months,
  };
};

/** @public */
AnonymizationSettingsView.prototype.getLabel = function() {
  throw new Error('Not implemented');
};

/** @override */
AnonymizationSettingsView.prototype.renderDisplay = function() {
  var anonEnabled = this.model.get('anonymizeEnabled') == true;
  var months = this.model.get('anonymizeAfterMonths');

  if (!anonEnabled) {
    this.$viewMode.html(yext.msg('Disabled'));
  } else {
    this.$viewMode.html(this.getLabel(months));
  }
};

exports = AnonymizationSettingsView;
